import React, { FC, LegacyRef } from 'react'
// components
import UserInfo from 'pages/NavBar/UserInfo'
import { OldButton } from 'components/Button'
// types
import { Classes } from 'jss'
import { ButtonTypes, UserType } from 'types/common'
// styles
import { sheet } from './sheet'
import injectSheet from 'react-jss'
// icons
import Active from 'components/svgComponent/Active'
import NonActive from 'components/svgComponent/NonActive'
import Plus from 'components/svgComponent/Plus'
import LogOut from 'components/svgComponent/LogOut'
import { ReactComponent as Settings } from 'components/svg/Settings.svg'
import { ReactComponent as Logout } from 'components/svg/Logout.svg'
// utils
import { ServerRoles } from 'lib/roles'
import UserDropdown from '../UserDropdown'
import { Button } from 'components/ui/Button'
import { Divider } from 'components/ui/Divider'

interface Props {
  classes: Classes
  user: UserType
  signOut: () => void
  openCloseMenu: () => void
  setWrapperRef: LegacyRef<HTMLDivElement>
  toggleModalInvite: () => void
  toggleModalAddClient: () => void
}
const Menu: FC<Props> = ({
  classes,
  user,
  signOut,
  openCloseMenu,
  setWrapperRef,
  toggleModalInvite,
  toggleModalAddClient
}) => {
  const invite = () => {
    openCloseMenu()
    toggleModalInvite()
  }

  const addClient = () => {
    openCloseMenu()
    toggleModalAddClient()
  }

  return (
    <div className={`${classes.root} `} ref={setWrapperRef}>
      <UserDropdown
        email={user.get('email')}
        photo={user.get('avatar')}
        firstName={user.get('firstName')}
        lastName={user.get('lastName')}
      />
      <Divider />

      <Button
        Icon={() => <Settings />}
        variant="text"
        size="lg"
        label="Profile Setting"
        onClick={openCloseMenu}
        to={'/profile'}
      />
      <Divider />

      {user.get('role') === ServerRoles.manager && (
        <div className={classes.linkGroup}>
          <OldButton Icon={Plus} label="Invite Recruiter" onClick={invite} />
          <Divider />

          <OldButton
            buttonStyle={true}
            isLink={true}
            Icon={Active}
            label="Post new job"
            to="/jobs/new"
            onClick={openCloseMenu}
          />
          <Divider />

          <OldButton Icon={NonActive} label="Add Client" onClick={addClient} />
        </div>
      )}
      <Button
        color="second"
        Icon={() => <Logout />}
        variant="text"
        size="lg"
        label="Sign Out"
        onClick={signOut}
      />
    </div>
  )
}

export default injectSheet(sheet)(Menu)
